/* Page Initalization */
document.addEventListener('DOMContentLoaded', init, false);

function init(){
  handleUTM();
  handleGEO();
  quicklink();
  
  adsBlocked(function(blocked){
    if(blocked){
      console.log('adblocker detected');
      dataLayer.push({ 
        event: 'page_view_adblocker'
      });
    } else {
      dataLayer.push({ 
        event: 'page_view_utm'
      });
    }
  })
}

/* UTM */
  // save UTM parameters to cookies
  function handleUTM() {
    if (window.location.search) {
      var source = getURLParam('utm_source');  
      if(source) {  
        Cookies.set('utm_source', source, {
          expires: 365,
          path: '/',
          domain: window.location.hostname,
          secure: true
        });
      }

      var medium = getURLParam('utm_medium');
      if(medium) {  
        Cookies.set('utm_medium', medium, {
          expires: 365,
          path: '/',
          domain: window.location.hostname,
          secure: true
        });
      }

      var term = getURLParam('utm_term');
      if(term) {
        Cookies.set('utm_term', term, {
          expires: 365,
          path: '/',
          domain: window.location.hostname,
          secure: true
        });
      }

      var campaign = getURLParam('utm_campaign');
      if(campaign) {
        Cookies.set('utm_campaign', campaign, {
          expires: 365,
          path: '/',
          domain: window.location.hostname,
          secure: true
        });
      }

      var content = getURLParam('utm_content');
      if(content !== null) {
        Cookies.set('utm_content', content, {
          expires: 365,
          path: '/',
          domain: window.location.hostname,
          secure: true
        });
      }
    }

    if (document.referrer) {
      var referrer = document.referrer;
      Cookies.set('referrer', content, {
        expires: 365,
        path: '/',
        domain: window.location.hostname,
        secure: true
      });

      dataLayer.push({
        referrer: Cookies.get('referrer'),
      });
    }

    if (Cookies.get('utm_source')) {
      dataLayer.push({
        campaignSource: Cookies.get('utm_source'),
        campaignMedium: Cookies.get('utm_medium'),
        campaignName: Cookies.get('utm_campaign'),
        campaignKeyword: Cookies.get('utm_term'),
        campaignContent: Cookies.get('utm_content'),
      });
    }

    dataLayer.push({ 
      event: 'page_view_utm'
    });

    populateUTMs();
  }

  // Populate forms with UTM's
  function populateUTMs() {
    if ($('.input-source')) {
      $('.input-source').val(Cookies.get('utm_source'));
      $('.input-medium').val(Cookies.get('utm_medium'));
      $('.input-campaign').val(Cookies.get('utm_campaign'));
      $('.input-term').val(Cookies.get('utm_term'));
      $('.input-content').val(Cookies.get('utm_content'));
      $('.input-referrer').val(Cookies.get('referrer'));
    }
  }


  function adsBlocked(callback){
    var testURL = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js'

    var myInit = {
      method: 'HEAD',
      mode: 'no-cors'
    };

    var myRequest = new Request(testURL, myInit);

    fetch(myRequest).then(function(response) {
      return response;
    }).then(function(response) {
      console.log(response);
      callback(false)
    }).catch(function(e){
      console.log(e)
      callback(true)
    });
  }

/* Product Recommendations */

  // Populate and show modal showing their recommended product from last time. Only shows once.
  function handleProductModal() {
    var product = localStorage.getItem('product');

    if (product) {
      product = JSON.parse(product);
      var $modal = $('.modal-product');

      if (product.image) {
        $modal.find('.product-modal-link').attr('href', product.url);
        $modal.find('.product-modal-image').attr('src', product.image).attr('srcset', product.image);
        $modal.find('.product-modal-title').text(product.name);

        setTimeout(function() {
          showModal($modal);
          localStorage.setItem('sawProductModal', true);
        }, 3000);
      } else {
        // fallback in case the image isn't saved (because they visited before this modal was made)
        handleProductBanner(); 
      }
    }
  }

  // Shows a banner linking to their recommended product. Only shows if the modal fails or if they already saw it
  function handleProductBanner() {
    var product = localStorage.getItem('product');

    if (product) {
      product = JSON.parse(product);
      var sawProductModal = localStorage.getItem('sawProductModal')

      if (product.image && !sawProductModal) {
        handleProductModal();
      } else {
        var $banner = $('.product-banner');

        $banner.attr('href', product.url);
        $banner.find('.banner-product').text(decodeURI(product.name));

        setTimeout(function() {
          $banner.addClass('shown');
          var $hero = $('.hero');

          $('.hero').animate({'padding-top': parseInt($hero.css('padding-top')) + 40 + 'px'}, 150);
        }, 3000);
      }

    }
  }

/* Tracking Events */
  $(document).ready(function() {
    /*$('.newsletter-form').on('submit', function() {
      var position = $(this).attr('position');

      dataLayer.push({
        position: position
      });
    });
    */
    $('a[quiz-track="true"]').on('click', function() {
      var position = $(this).attr('position');
      dataLayer.push({
        event: 'quiz_cta',
        position: position,
      });
    });

    $('a[social-track="true"]').on('click', function() {
      var position = $(this).attr('position');
      dataLayer.push({
        event: 'social_cta',
        position: position,
      });
    });

    $('a[social-share="true"]').on('click', function() {
      var channel = $(this).attr('channel');
      dataLayer.push({
        event: 'social_share',
        channel: channel,
      });
    });

    $('a[email-track="true"]').on('click', function() {
      var position = $(this).attr('position');
      dataLayer.push({
        event: 'click_email',
        position: position,
      });
    });

    $('.hero-gender').on('click', function() {
      var $this = $(this);
      var gender = $this.attr('gender');

      localStorage.setItem('gender', gender);
    });
  });


/* Geo customizations */
  function handleGEO() {
    var hasGeo = typeof geoip2 !== 'undefined' ? true : false;

    if (hasGeo) {
        geoip2.city(function (result) {

        if (result) {
          var country = result.country;
          var iso = country.iso_code

          if (iso === 'US' || iso === 'CA') {
            var location = '';
            var locationISO = '';

            if (result.subdivisions && result.subdivisions[0].names && result.subdivisions[0].names.en) {
              location = result.subdivisions[0].names.en;
              locationISO = result.subdivisions[0].iso_code;
            } else if (country) {
              location = country.names.en;
              locationISO = iso;
            }

            if (location) {
              $('.state-text').text(location);
              $('#footer .state-text').text(locationISO);
            }            
          }

          // if Canada, show them that the prices are in USD
          if (iso === 'CA') {
            var $price = $('.product-price').eq(0);

            if ($price) {
              var price = `${$price.text()} USD`;

              $('.product-price').text(price);
            }
          }
        }
      });
    }

    $('.custom-text').fadeIn(50);
  }

/* Record visit */
  // if they've visited the site before, we add a button to the hero so they can fast track down the funnel
  function recordVisitAndHandleReturn() {
    var hasVisited = localStorage.getItem('hasVisited');

    if (!hasVisited) {
      localStorage.setItem('hasVisited', true);
    } else {
      $('.hero .button-row').css({display: 'flex'});
      $('.revisit-content').fadeIn(50);
    }
  }

/* Modal behavior */
  $(document).ready(function(){
    // allows the modal screen to fade in and be display flex
    $('.modal').css({display: 'none', 'z-index': 1000});
    
    facebookModal();
    

    $('.modal-close').on('click', function(e) {
      hideModal($('.modal'));
    });
  });

  function facebookModal() {
	var mouseY = 0;
    var topValue = 0;

    var $facebookModal = $('.facebook-modal');
    var isMobile = window.outerWidth < 768;

    if ($facebookModal.length > 0 && !isMobile) {
      window.addEventListener("mouseout",function(e){

        if (!localStorage.getItem('sawFacebookModal')) {
          mouseY = e.clientY;

          if(mouseY < topValue && $facebookModal.is(':hidden')) {
            console.log('showing exit modal!')
            //$facebookModal.fadeIn(200);
            showModal($facebookModal);

            localStorage.setItem('sawFacebookModal', true);
          }
        }
      },
      false);


      setTimeout(function() {
        if (!localStorage.getItem('sawFacebookModal')) {
          showModal($facebookModal);
          localStorage.setItem('sawFacebookModal', true);
        }
      }, 300000); // 5 mins

    } else {

    }
  }

  function showModal($modal) {
    $modal.fadeIn(150);
    $('.body').addClass('modal-open').css({position:'fixed'});;
  }

  function hideModal($modal) {
    $modal.fadeOut(150);
    $('.body').removeClass('modal-open').css({position:'static'});;
  }

/* Videos */
  $(document).ready(function() {
    $('.play-video-button').fancybox();
    
    $('.play-video-button').on('click', function(e) {
      dataLayer.push({
        event: 'watch_product_video'
      });
    });
  });


// Nav Dropdown
  $('.dropdown-link').on('click', function(e) {
    var $t = $(this);
    e.preventDefault();
    
    $t.toggleClass('active');
    
    var $dropdown = $('.nav-dropdown.desktop');
    
    if (window.outerWidth <= 991) {
      $dropdown = $('.nav-dropdown.mobile');
    }
    
    if ($t.hasClass('active')) {
      $dropdown.slideDown(150);
    } else {
      $dropdown.slideUp(150);
    }
  });
